import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewEncapsulation} from '@angular/core';
import { NotificationService } from './notification.service';

@Component({
    selector: 'my-notification',
    templateUrl: './notification.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {

    public notificationList: Array<any> = [];

    constructor(
        private _notificationService: NotificationService,
        private cd: ChangeDetectorRef
    ) { }

    public ngOnInit() {
        NotificationService.notificationQueue$.subscribe(notification => {
            if (notification.timeoutBeforeClose) {
                setTimeout(() => {
                    this.clearNotification(notification);
                }, notification.timeoutBeforeClose);
            }

            this.notificationList.push(notification);
            this.cd.markForCheck();
        });

        NotificationService.removedNotificationQueue$.subscribe(notification => {
            this.clearNotification(notification);
        });
    }

    public clearNotification(notification: any) {
        let index = this.notificationList.indexOf(notification);
        if (index !== -1) {
            this.notificationList.splice(index, 1);
            this.cd.markForCheck();
        }
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/notification/notification.component.ts